import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { profileReducer } from "@/components/profile";
import { historyReducer } from "@/components/history";
import { evaluateReducer } from "@/components/evaluate/evaluateSlice";
import { evaluationDetailReducer } from "@/components/evaluation-detail";
import { pricingReducer } from "@/components/pricing/pricingSlice";
// Import reducer directly to avoid circular dependency issues
import loginSignupReducer from "@/components/login-signup/LoginSignupSlice";
import { setStoreGetter as setAxiosStoreGetter } from "./axios";
import { setStoreGetter as setWebSocketStoreGetter } from "@/utils/websocket";

const rootReducer = combineReducers({
  loginSignup: loginSignupReducer,
  profile: profileReducer,
  history: historyReducer,
  evaluate: evaluateReducer,
  evaluationDetail: evaluationDetailReducer,
  pricing: pricingReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["loginSignup", "profile"],
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [PERSIST, REGISTER, PURGE],
      },
    }),
  devTools: import.meta.env.VITE_APP_ENV === "development",
});

export const persistor = persistStore(store);

// Set store getter for axios interceptor (avoids circular dependency)
// Using static import to ensure it's set immediately before any API calls
setAxiosStoreGetter(() => store);

// Set store getter for WebSocket
setWebSocketStoreGetter(() => store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
